import { ENDPOINT_INDEX, ENDPOINT_INDEX_ORDERBY, ENDPOINT_INDEX_SET_PAGE, ENDPOINT_INDEX_FILTER } from 'client/redux/endpoint/constants';
import { reduceTableActions } from 'client/redux/table/reducerHelpers';
import { reduceByTypes } from 'client/redux/apiHelpers';

const defaultState = {
  error: null,
  isReading: false,
  logs: null,
  filter: {connectorId: '', type: '', level: '', timeStart: '', timeEnd: '', connectorInstanceId: ''},
  page: 1,
  orderBy: 'updatedAt',
  orderDirection: 'DESC',
};

export default function indexReducer (state = defaultState, action) {
  state = reduceByTypes(ENDPOINT_INDEX, state, action, {requestProp: 'isReading', successSpread: true});
  state = reduceTableActions([ENDPOINT_INDEX_FILTER, ENDPOINT_INDEX_SET_PAGE, ENDPOINT_INDEX_ORDERBY], state, action);
  return state;
}
